import api from '../../utils/api'

import { useState } from 'react'



/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormCommission from './Form/FormCommission'

function NewCommission({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()



    async function registerCommission(commission) {
        let msgType = 'success'

        const data = await api.post('/commission/new', commission, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <FormCommission title="Cadastrar Comissão" handleSubmit={registerCommission} btCancelAction={btCancelAction} btnText="Cadastrar" />
    )
}

export default NewCommission
